/* NEW: UI_REVAMP */
export const getOddsAmount = (bet) => {
	if (typeof bet.winRate === 'number') return bet.winRate;
	if (!bet.odds || bet.odds.length === 0) return 0;
	if (bet.betType === 'Ramble') {
		if (['SWER3', 'MANDAUE', 'RG7'].includes(bet.gameType)) {
			const uniqueCount = new Set(bet.digit.split('')).size;
			const permutation = uniqueCount === 3 ? 6 : uniqueCount === 2 ? 3 : 1;
			return bet.odds.find((o) => o.comboCount === permutation)?.winRate ?? 0;
		}
		return bet.odds.find((o) => o.comboCount > 1)?.winRate ?? 0;
	}
	return bet.odds.find((o) => o.comboCount === 1)?.winRate ?? 0;
};
